import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const hpinfoGetFavoriteSlice = createSlice({
  name: 'hpinfoGetFavorite',
  initialState: { hpinfoGetFavorite: initialState },
  reducers: {
    hpinfoGetFavoriteApi: (state, data) => {
      state.hpinfoGetFavorite = data.payload;
    },
  },
});

export const { hpinfoGetFavoriteApi } = hpinfoGetFavoriteSlice.actions;

export default hpinfoGetFavoriteSlice.reducer;
